module.exports = __webpack_public_path__ + "img/60.36ea10e2.jpg";